export default __webpack_public_path__ + "static/media/clanguage.409f87a4.svg";